import Messages from 'GenericTexting/components/Messages';
import ClientMessages from 'GenericTexting/components/ClientMessages';
import React from 'react';
import {Route, Switch} from 'react-router';
import Dispositions from './components/Dispositions';
import Clients from './components/Clients';
import Keywords from './components/Keywords';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';

const ROOT_URI = '/messaging';
const MESSAGES_ROOT_URI = `${ROOT_URI}/message`;

export const SubscriptionsRouteConstants = {
  MESSAGES: MESSAGES_ROOT_URI,
  CLIENT_MESSAGES: `${MESSAGES_ROOT_URI}/aggregation/client`,
  CLIENTS: `${MESSAGES_ROOT_URI}/client`,
  KEYWORDS: `${MESSAGES_ROOT_URI}/keyword`,
  MESSAGE_DISPOSITIONS: `${MESSAGES_ROOT_URI}/disposition`,
};
export default () => {
  return (
    <Route
      path={ROOT_URI}
      render={() => (
        <Switch>
          <Route path={SubscriptionsRouteConstants.MESSAGES} render={() => <RoutesUnderMessaging />} />
        </Switch>
      )}
    />
  );
};

const RoutesUnderMessaging = () => {
  useBreadcrumbs('Messaging', SubscriptionsRouteConstants.MESSAGES);
  return (
    <Switch>
      <Route exact path={SubscriptionsRouteConstants.MESSAGES} render={() => <Messages />} />
      <Route exact path={SubscriptionsRouteConstants.CLIENT_MESSAGES} render={() => <RoutesUnderClientMessages />} />
      <Route exact path={SubscriptionsRouteConstants.CLIENTS} render={() => <RoutesUnderClients />} />
      <Route exact path={SubscriptionsRouteConstants.MESSAGE_DISPOSITIONS} render={() => <RoutesUnderDispositions />} />
      <Route exact path={SubscriptionsRouteConstants.KEYWORDS} render={() => <RoutesUnderKeywords />} />
    </Switch>
  );
};

const RoutesUnderClientMessages = () => {
  useBreadcrumbs('Client Messages', SubscriptionsRouteConstants.CLIENT_MESSAGES);
  return (
    <Switch>
      <Route exact path={SubscriptionsRouteConstants.CLIENT_MESSAGES} render={() => <ClientMessages />} />
    </Switch>
  );
};

const RoutesUnderDispositions = () => {
  useBreadcrumbs('Dispositions', SubscriptionsRouteConstants.MESSAGE_DISPOSITIONS);
  return (
    <Switch>
      <Route exact path={SubscriptionsRouteConstants.MESSAGE_DISPOSITIONS} render={() => <Dispositions />} />
    </Switch>
  );
};

const RoutesUnderClients = () => {
  useBreadcrumbs('Clients', SubscriptionsRouteConstants.CLIENTS);
  return (
    <Switch>
      <Route exact path={SubscriptionsRouteConstants.CLIENTS} render={() => <Clients />} />
    </Switch>
  );
};

const RoutesUnderKeywords = () => {
  useBreadcrumbs('Keywords', SubscriptionsRouteConstants.KEYWORDS);
  return (
    <Switch>
      <Route exact path={SubscriptionsRouteConstants.KEYWORDS} render={() => <Keywords />} />
    </Switch>
  );
};
